import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';


@Component({
  selector: 'm-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  constructor( private dialogRef: MatDialogRef<ModalComponent>, @Inject(MAT_DIALOG_DATA) public data ) {
    dialogRef.disableClose = true;
   }

  ngOnInit() {
    //debugger
    // console.log(this.data);
  }

  onButtonClick(button?){
      this.dialogRef.close(button);
  }
}
